import { Link } from 'react-router-dom'

/** Amber pill. Links to the watchlist profile. Stops the click from opening the parent row. */
export default function WatchlistBadge({ memberId, className = '' }) {
  const id = String(memberId || '').trim()
  if (!id) return null
  return (
    <Link
      to={`/monitor-safe/watch-list/${encodeURIComponent(id)}`}
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center px-1.5 py-0.5 text-[10px] font-semibold rounded border border-amber-300 bg-amber-100 text-amber-950 hover:bg-amber-200 ${className}`}
      title="Open watchlist profile"
    >
      Watchlist
    </Link>
  )
}
